// Central, typed config for brand assets and theme tokens.
import {
  Full as PropfitFull,
  FullMono as PropfitFullMono,
  Square as PropfitSquare,
  SquareMono as PropfitSquareMono,
} from '~/brand/generated/propfit.app';
import {
  SvgFullTrakmate as TrakmateFull,
  SvgFullTrakmateMono as TrakmateFullMono,
  Square as TrakmateSquare,
  SvgSquareMono as TrakmateSquareMono,
} from '~/brand/generated/trakmate.app';

export type BrandKey = 'propfit' | 'trakmate';

export const BRAND_HELP_URL = 'https://help.gfactor.com';

export type BrandTheme = {
  key: BrandKey;
  name: string;
  url: string;
  helpUrl: string;
  // React components for SVGs
  logo: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  authLogo?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  square?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  squareMono?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  colors?: {
    primary: string;
  };
};

export const BRANDS: Record<BrandKey, BrandTheme> = {
  propfit: {
    key: 'propfit',
    name: 'PropFit',
    url: 'https://prop.fit',
    helpUrl: BRAND_HELP_URL,
    logo: PropfitFull,
    authLogo: PropfitFullMono ?? PropfitFull,
    square: PropfitSquare,
    squareMono: PropfitSquareMono ?? PropfitSquare,
    colors: { primary: '#0D6EFD' },
  },
  trakmate: {
    key: 'trakmate',
    name: 'TrakMate',
    url: 'https://trakmate.io',
    helpUrl: BRAND_HELP_URL,
    logo: TrakmateFull as unknown as React.ComponentType<
      React.SVGProps<SVGSVGElement>
    >, // generated name differs
    authLogo:
      (TrakmateFullMono as unknown as React.ComponentType<
        React.SVGProps<SVGSVGElement>
      >) ??
      (TrakmateFull as unknown as React.ComponentType<
        React.SVGProps<SVGSVGElement>
      >),
    square: TrakmateSquare,
    squareMono:
      (TrakmateSquareMono as unknown as React.ComponentType<
        React.SVGProps<SVGSVGElement>
      >) ?? TrakmateSquare,
    colors: { primary: '#7C3AED' },
  },
};
